// import required libraries
import $ from 'jquery';
import {createRoot} from 'react-dom/client';
import React from 'react'

// import components that run on every page
import announcementBanner from "./actions/announcementBanner";
import hamburgerMenu from './components/hamburgerMenu';
import HeaderMenu from './components/Menus/App';
import Menu from './components/Menus/MenuBlock'
import quoteSlider from './components/Sliders/QuoteSlider';
import imageSlider from './components/Sliders/ImageSlider';
import MobileSlider from "./components/Sliders/MobileSlider";
import Header from "./components/Header";
import RelatedMediaCard from './components/Cards/RelatedMediaCard';
import NewsCard from './components/Cards/NewsCard';
import WhatsHappeningCard from './components/Cards/WhatsHappeningCard';
import videoPlayer from './components/videoPlayer';
import Cart from './components/Cart';

// Import Pages
import accessibility from './actions/accessibility';
import PageFrontPage from './pages/PageFrontPage';
import PageNews from './pages/PageNews';
import PageAbout from './pages/PageAbout';
import PageNewsIndex from './pages/PageNewsIndex'
import PageResourcesIndex from './pages/PageResourcesIndex'
import PagePerformance from './pages/PagePerformance'
import PageFordsMedia from './pages/PageFordsMedia';
import PageMediaIndex from './pages/PageMediaIndex';
import PageTimeline from './pages/PageTimeline';
import PageCalendar from './pages/PageCalendar';

// call functions
accessibility();
PageFrontPage($);
PageNews($);
PageAbout($);
PageNewsIndex($);
PagePerformance($);
announcementBanner($);
hamburgerMenu($);
PageFordsMedia($);
quoteSlider();
imageSlider();
Header($);
PageResourcesIndex($);
PageMediaIndex($);
MobileSlider($);
PageTimeline($);
PageCalendar($);
videoPlayer($);

const headerRootElement = document.getElementById("js-main-menu__container");
const headerRoot = createRoot(headerRootElement);

headerRoot.render (
	<HeaderMenu />
)

const sidebarRootElement = document.getElementsByClassName("js-sidebar-block");
if (sidebarRootElement.length > 0) {
	const sidebarRoot = createRoot(sidebarRootElement[0]);
	sidebarRoot.render (
		<Menu {...sidebarRootElement[0].dataset} />
	)
}

const relatedMediaCardElements = document.getElementsByClassName("js-related-media-card");

Array.from(relatedMediaCardElements).forEach((card) => {
	const relatedMediaCardRoot = createRoot(card);
	relatedMediaCardRoot.render(<RelatedMediaCard {...card.dataset} />);
});

const recentNewsCardElements = document.getElementsByClassName("js-recent-news-card");

Array.from(recentNewsCardElements).forEach((card) => {
	const recentNewsCardRoot = createRoot(card);
	recentNewsCardRoot.render(<NewsCard {...card.dataset} />);
});

const whatsHappeningCardElements = document.getElementsByClassName("js-whats-happening-card");

Array.from(whatsHappeningCardElements).forEach((card) => {
	const whatsHappeningRoot = createRoot(card);
	whatsHappeningRoot.render(<WhatsHappeningCard {...card.dataset} />);
});

const cartRootElement = document.getElementById("js-cart");
const cartRoot = createRoot(cartRootElement);

cartRoot.render (
	<Cart />
)
